import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { CustomAlertModalComponent } from 'app/shared/shared-component/custom-alert-modal/custom-alert-modal.component';

@Component({
	selector: 'jhi-eappreg-selects',
  templateUrl: './eappreg-selects.component.html',
  styleUrls: ['./eappreg-selects.component.scss']
})

export class EappregSelectsComponent  { 
errorMessage = "You have not selected any of the questions.Please select any one of them."

ftQuestion = 'fasttrackQuestions'; 
normalQuestion='normalQuestions';
selectAnswer  =""   
    question: any;
    errorExist = false
   res: any;
 ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
    };
constructor(private router: Router , private modalService: NgbModal
 ){
	history.pushState(null, "", window.location.href);
		window.onpopstate = function() {
			history.go(1);
		};
}
select(event: any) : void {
		this.selectAnswer = event.target.value
}
submit() : void {
	if(this.ftQuestion === this.selectAnswer ){
		this.router.navigate(['/eappreg_fasttrack'])}
    else if(this.normalQuestion===this.selectAnswer){
		this.router.navigate(['/eappreg_questionnaire'])	
		}
	else{
		const title = "Confirmation"
      const body = "Please Select any of the options."
      const modalRef = this.modalService.open(CustomAlertModalComponent, this.ngbModalOptions)
      modalRef.componentInstance.cModalTitle = title
      modalRef.componentInstance.cModalBody = body
      modalRef.result.then((userResponse) => {
        if (userResponse === "OK") {
          this.router.navigate(['/eappreg_selects']);
        }
      });
	}	

        }


}

